import { RgCreate, DefaultPlot } from "@project-rouge/rg-core";
import { Vector3toV3, intersectPolygons, offsetPolygon, differencePolygons } from "@project-rouge/rg-three";
import seedrandom from "seedrandom";
import { optimisePlots } from "./index184.js";
import { recursiveSubdivision } from "./index185.js";
import { getActiveZones } from "./index186.js";
const pipeAddPlots = ([parent, { aggProps, optimise }]) => {
  const rvData = aggProps.dataset.rvData;
  const zones = getActiveZones(parent, aggProps);
  const face2face = aggProps.face2FaceSeparation ?? aggProps.dataset.aggConfig.face2FaceSeparation;
  const { corridorWidth, moduleDepth } = aggProps.dataset.aggConfig;
  const tailorData = { mainThreads: [], mainFrozenThreads: [] };
  for (const zone of zones) {
    const divisionData = [];
    const zoneProps = aggProps.zones[zone.uuid];
    const rng = seedrandom(`${zoneProps.subdivisionSeed}`);
    for (let i = 0; i < zone.data.polygons.length; i++) {
      const zonePolygonOffset = offsetZonePolygon({ zone, zones, i, face2face });
      const { polygons: plotPolys, root } = recursiveSubdivision({
        poly: zonePolygonOffset,
        rng,
        maxCount: zoneProps.maxPlotCount,
        maxLength: zoneProps.maxLength,
        minWidth: zoneProps.minWidth ?? corridorWidth + 2 * moduleDepth + face2face,
        minArea: zoneProps.minArea,
        allowLongitudinalSplit: zoneProps.allowLongitudinalSplit
      });
      divisionData.push(root);
      const newPlotPolys = retrimPolys(zone, i, plotPolys);
      createPlots(newPlotPolys, zone, i, rvData);
    }
    if (optimise) {
      const { tailorDataOut } = optimisePlots(zone, aggProps, divisionData);
      tailorData.mainThreads.push(...tailorDataOut.mainThreads);
      tailorData.mainFrozenThreads.push(...tailorDataOut.mainFrozenThreads);
    }
  }
  return [parent, tailorData];
};
function retrimPolys(zone, i, plotPolys) {
  let newPlotPolys = [];
  const originalZonePolygon = zone.data.polygons[i].map(Vector3toV3);
  const plotPolysCopy = plotPolys.map((poly) => poly.map(Vector3toV3));
  newPlotPolys = plotPolysCopy.flatMap((c) => intersectPolygons(originalZonePolygon, [c]));
  return newPlotPolys;
}
function createPlots(newPlotPolys, zone, i, rvData) {
  for (const polygon of newPlotPolys) {
    const plot = RgCreate({
      ...DefaultPlot,
      parent: zone,
      data: {
        polygon,
        zonePolyIndex: i
      }
    }, rvData);
    zone.children.push(plot);
  }
}
function offsetZonePolygon({ zone, zones, i, face2face }) {
  let zoneOffset = offsetPolygon(zone.data.polygons[i], 0.5 * face2face);
  const otherZonePolys = zones.filter((z) => z !== zone).flatMap((z) => z.data.polygons.map((poly) => poly.map(Vector3toV3)));
  otherZonePolys.push(zone.data.polygons.filter((_v, index) => index !== i).flatMap((poly) => poly.map(Vector3toV3)));
  if (otherZonePolys.length > 0)
    zoneOffset = differencePolygons(zoneOffset, otherZonePolys)[0];
  return zoneOffset;
}
export {
  pipeAddPlots
};
//# sourceMappingURL=index92.js.map
